import * as React from "react";
import { SVGProps } from "react";

const Kin = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2000 2000" {...props}>
    <path
      fill="#005fff"
      d="M1432.19 727.27H1303V598.1a83 83 0 0 1 83-83h46.19a83 83 0 0 1 83 83v46.2a83 83 0 0 1-83 82.97m-735.19 0H567.8a83 83 0 0 1-83-83V598.1a82.94 82.94 0 0 1 83-83H614a83 83 0 0 1 83 83zm-83 787.88h-46.19a83 83 0 0 1-83-83V1386a83 83 0 0 1 83-83H697v129.15a83 83 0 0 1-83 83m818.19 0H1386a83 83 0 0 1-83-83V1303h129.16a83 83 0 0 1 83 83v46.2a83 83 0 0 1-83 83"
    />
    <path
      fill="#0ce"
      d="M1038.25 515.15h-46.2a83 83 0 0 1-83-83V386a83 83 0 0 1 83-83h46.19a83 83 0 0 1 83 83v46.2a83 83 0 0 1-83 83m.01 1212.07h-46.2a83 83 0 0 1-83-83v-46.2a83 83 0 0 1 83-83h46.19a83 83 0 0 1 83 83v46.2a83 83 0 0 1-83 83m606.07-606.06h-46.19a83 83 0 0 1-83-83V992a83 83 0 0 1 83-83h46.19a83 83 0 0 1 83 83v46.2a83 83 0 0 1-83 83m-1212.12.01H386a83 83 0 0 1-83-83V992a83 83 0 0 1 83-83h46.19a83 83 0 0 1 83 83v46.2a83 83 0 0 1-83 83"
    />
    <path
      fill="#005fff"
      d="M1247 1811.07a60.59 60.59 0 1 1 79.17 32.78 60.61 60.61 0 0 1-79.17-32.78M610.69 265.61a60.59 60.59 0 1 1 79.17 32.78 60.61 60.61 0 0 1-79.17-32.78M1780.76 753a60.59 60.59 0 1 1 32.78-79.17 60.61 60.61 0 0 1-32.78 79.17M265.61 1389.31a60.59 60.59 0 1 1 32.78-79.17 60.61 60.61 0 0 1-32.78 79.17"
    />
    <path
      fill="#002dae"
      d="M1734.39 1389.31a60.59 60.59 0 1 1 79.17-32.79 60.58 60.58 0 0 1-79.17 32.79M219.24 753a60.59 60.59 0 1 1 79.17-32.79A60.58 60.58 0 0 1 219.24 753M1359 265.61a60.59 60.59 0 1 1-32.79-79.17 60.58 60.58 0 0 1 32.79 79.17M722.65 1811.07a60.59 60.59 0 1 1-32.79-79.17 60.58 60.58 0 0 1 32.79 79.17"
    />
    <path
      fill="#0099c0"
      d="M1645.24 1718.39a30.3 30.3 0 1 1 42.85 0 30.29 30.29 0 0 1-42.85 0M281.61 354.76a30.3 30.3 0 1 1 42.85 0 30.29 30.29 0 0 1-42.85 0m1406.48 0a30.3 30.3 0 1 1 0-42.85 30.29 30.29 0 0 1 0 42.85M324.46 1718.39a30.3 30.3 0 1 1 0-42.85 30.29 30.29 0 0 1 0 42.85"
    />
    <path
      fill="#0029c0"
      d="M1969.7 1030.3a30.3 30.3 0 1 1 30.3-30.3 30.31 30.31 0 0 1-30.3 30.3m-1939.4 0a30.3 30.3 0 1 1 30.3-30.3 30.31 30.31 0 0 1-30.3 30.3m1000-1000A30.3 30.3 0 1 1 1000 0a30.31 30.31 0 0 1 30.3 30.3m0 1939.4a30.3 30.3 0 1 1-30.3-30.3 30.31 30.31 0 0 1 30.3 30.3"
    />
    <path
      fill="#003ec5"
      d="M1202.22 899h45.24a55.58 55.58 0 0 0 55.54-55.58V697h-146.41a55.59 55.59 0 0 0-55.59 55.56V798a101 101 0 1 1-202 0v-47.45A53.59 53.59 0 0 0 845.41 697H697v606h147.3a54.72 54.72 0 0 0 54.7-54.7V1202a101 101 0 0 1 101-101v.2a101 101 0 0 1 101 101v45.67a55.14 55.14 0 0 0 55.14 55.14H1303v-146.86a55.14 55.14 0 0 0-55.14-55.14H1202a101 101 0 0 1-101-101h.2a101 101 0 0 1 101-101"
    />
  </svg>
);

export default Kin;
